import styled from "styled-components";

export const CastAndCrewContainer = styled.div`
  margin-top: 20px;
  font-family: "Open Sans", sans-serif;
`;

export const ItemContainer = styled.div`
  width: ${(props) => props.$width + "px"};
  transition: transform 0.2s ease-in-out;
  margin-right: ${(props) => props.$marginRight + "px"};

  &:hover {
    transform: scale(1.08);
  }
`;

export const RouteAnchor = styled.a`
  text-decoration: none;
`;

export const ThumbnailContainer = styled.div`
  border-radius: ${(props) => props.$borderRadius};
  height: ${(props) => props.$height + "px"};
  width: ${(props) => props.$width + "px"};
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(0, 0, 0, 0);

  &:hover {
    border: 2px solid #fff;
  }
`;

export const ThumbnailImage = styled.img`
  background-color: #c4c4c4;
  display: block;
`;

export const MetadataContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 6px;
  margin-left: 2px;
`;

export const TextContainer = styled.div`
  max-width: ${(props) => props.$maxWidth + "px"};
`;

const MetadataInfo = styled.p`
  margin: 0;
  line-height: 135%;
  max-height: 112px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

export const Title = styled(MetadataInfo)`
  font-weight: 600;
  font-size: 20px;
  color: #fff;
`;

export const SubTitle = styled(MetadataInfo)`
  font-weight: 400;
  font-size: 18px;
  color: #b0b0b0;
`;
